import { motion } from "framer-motion";
import { Flag } from "lucide-react";
import { Link } from "react-router-dom";
import { revealRight, Eyebrow, GoldButton, MECHANISM_IMAGE, VIEWPORT } from "./primitives";
import { useLanguage } from "@/i18n/LanguageContext";

export const StolenSection = () => {
  const { t } = useLanguage();
  const features = t("stolen.features");
  return (
    <section
      id="montres-volees"
      data-testid="stolen-section"
      className="relative scroll-mt-28 py-14 md:py-32 border-t border-ink/5 overflow-hidden"
    >
      <div className="relative max-w-7xl mx-auto px-5 md:px-12 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={VIEWPORT}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="relative order-2 lg:order-1"
        >
          <div className="absolute -inset-3 border border-gold/20" />
          <img
            src={MECHANISM_IMAGE}
            alt={t("stolen.imageAlt")}
            loading="lazy"
            className="relative w-full aspect-[4/3] object-cover"
          />
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={VIEWPORT}
          variants={revealRight}
          className="order-1 lg:order-2"
        >
          <Eyebrow>{t("stolen.eyebrow")}</Eyebrow>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl tracking-tight mb-8">
            {t("stolen.title")}
          </h2>
          <ul className="mb-10 space-y-4 border-l border-gold/15 pl-6">
            {features.map((feature) => (
              <li key={feature} className="flex items-start gap-4">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center border border-gold/40 bg-gold/[0.06]">
                  <Flag size={12} className="text-gold-ink" />
                </span>
                <span className="text-sm md:text-base text-ink-body leading-relaxed">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
          <GoldButton to="/declarer-vol" testId="stolen-cta-button">
            {t("stolen.cta")}
          </GoldButton>
          <p className="mt-5 text-sm text-ink-muted">
            {t("stolen.guidePre")}{" "}
            <Link
              to="/signaler-vol-montre"
              className="text-gold-ink hover:underline underline-offset-2 transition-colors"
            >
              {t("stolen.guideLink")}
            </Link>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default StolenSection;
